// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602101544/js/" + chunkId + "." + {"44":"e43d74de","225":"654197b9","481":"53b041aa","486":"e47c94dc","770":"2da43e5a"}[chunkId] + ".0.41443451195599534.chunk.js";
};